<template>
  <div
    v-if="enableLiveEvents && addDrawer && (promptText && promptButtonLabels.btn_text)"
    class="mb-7 last:mb-0 text-center"
  >
    <p
      v-if="promptText"
      class="mb-4 text-white"
      v-html="promptText"
    />
    <MultiBtn
      v-if="promptButtonLabels.btn_text"
      icon="arrow"
      :theme="promptButtonStyles.button_style"
      :text="promptButtonLabels.btn_text"
      :label="promptButtonLabels.btn_title"
      @click.native="$store.commit('liveEventsModalOpen', true)"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MultiBtn from '@/components/buttons/MultiBtn.vue'

export default {
  name: 'LiveEventsPrompt',

  components: {
    MultiBtn
  },

  // Temporary while Stanga are creating their own drawer and toggles
  data: () => ({
    addDrawer: true
  }),

  computed: {
    // Store
    ...mapGetters([
      'liveEventsEnabled',
      'myStore',
    ]),
    // Options
    lepOptions() { return this.myStore(['options', 'live_events']) ?? {} },
    isAdminEnabled() { return this.liveEventsEnabled },
    isClientEnabled() { return this.lepOptions.enabled ?? false },
    enableLiveEvents() { return this.isAdminEnabled && this.isClientEnabled },
    // Text
    promptText() { return this.lepOptions.prompt_text ?? '' },
    promptButtonLabels() { return this.myStore(['labels', 'live_events', 'mobile_open_button']) ?? '' },
    promptButtonStyles() { return this.myStore(['styles', 'live_events', 'mobile_open_button']) ?? '' }
  }
}
</script>

